export default __webpack_public_path__ + "static/media/ishay-merling-9.7f69dbc9.png";